import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

// Vuetify 4 plugin. Components/directives are auto-imported by the
// `vite-plugin-vuetify` configured in vite.config.js — no need to enumerate.
// `@mdi/font` is loaded via CDN in index.html.
export default createVuetify({
  // Vuetify 4 reserves vertical space under every form control for the
  // `details` slot (hints / errors), even when nothing is rendered there.
  // The codebase rarely uses it (most validation is done outside Vuetify),
  // so `hide-details: 'auto'` cuts ~22px of dead space per field and stops
  // the stacked-form vertical sprawl the Vue 2 layout never had.
  //
  // Variant defaults match what the codebase used to pass everywhere via the
  // (now-removed) `outlined` boolean.
  defaults: {
    // density: 'compact' renders Vuetify inputs at ~40px tall — matches the
    // codebase's legacy <input class="form-control"> height so forms with
    // mixed Vuetify + Bootstrap-style inputs (eg the employee profile
    // address rows) line up visually.
    VTextField: { variant: 'outlined', hideDetails: 'auto', density: 'compact' },
    VTextarea: { variant: 'outlined', hideDetails: 'auto', density: 'compact' },
    // The codebase's DataSelect.js lists use `{ text, value }` everywhere
    // (Vuetify 2's default item keys). Default itemTitle/itemValue to those
    // shapes so existing <v-select :items="listGender">-style call sites
    // don't have to spell out the mapping. Sites that override (eg
    // item-title="name" / item-title="payslipName") still win because
    // explicit props beat global defaults.
    VSelect: { variant: 'outlined', hideDetails: 'auto', density: 'compact', itemTitle: 'text', itemValue: 'value' },
    VCombobox: { variant: 'outlined', hideDetails: 'auto', density: 'compact', itemTitle: 'text', itemValue: 'value' },
    VAutocomplete: { variant: 'outlined', hideDetails: 'auto', density: 'compact', itemTitle: 'text', itemValue: 'value' },
    VCheckbox: { hideDetails: 'auto', density: 'compact' },
    VRadioGroup: { hideDetails: 'auto', density: 'compact' },
    VSwitch: { hideDetails: 'auto', density: 'compact' },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          // Brand green — the same #09B585 that `--cyrus-green` (main.css) and
          // `.btn-primary` / `.btn-success` (style(1).css) paint. This used to be
          // #058560, which meant anything Vuetify tinted with `primary` (button
          // fills, outlined-field focus borders, checkboxes, date-picker
          // selection, stepper) rendered a visibly darker green than the
          // Bootstrap-era buttons sitting next to it. One green, app-wide.
          // See /design-system.md §3.1.
          primary: '#09B585',
        },
      },
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
})
